module.exports = __webpack_public_path__ + "static/img/02.0ddbd1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/03-hyCase/02.png
// module id = 5an0
// module chunks = 1